import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SiteService } from '../../services/site.service';
import { Contact, ArticleItem, BannerItem, ReviewItem } from '../../services/site.model';
import { Banners, ServicesList, Introduce, Reviews } from './data';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {

    constructor(
        private siteService: SiteService,
        private translate: TranslateService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private sanitizer: DomSanitizer
    ) {}
    banners: BannerItem[] = Banners;
    services: ArticleItem[] = ServicesList;
    introduce: ArticleItem[] = Introduce;
    reviews: ReviewItem[] = Reviews;
    formdata;
    emailid;
    invalidFields = [];
    submittedMail = false;
    isMissingField = false;
    error;
    @ViewChild('appointmentConfirmation') public appointmentConfirmation: TemplateRef<any>;

    ngOnInit(): void {
        this.formdata = new FormGroup({
            firstname: new FormControl('', Validators.required),
            lastname: new FormControl('', Validators.required),
            email: new FormControl(''),
            phone: new FormControl('', Validators.required),
            message: new FormControl('', Validators.required),
            agreement: new FormControl(false, Validators.required)
        });
        this.translate.onLangChange.subscribe((event) => {
            this.translate.setDefaultLang(event.lang);
        });
        this.activatedRoute.queryParams.subscribe(params => {
            if (params.section) {
                setTimeout(r => {
                    document.querySelector('#' + params.section).scrollIntoView();
                }, 1000);
            }
        });
        document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');
    }

    getContactFormFieldLabel(key): string {
        let label = '';
        switch (key) {
            case 'firstname':
                label = this.translate.instant('First Name');
                break;
            case 'lastname':
                label = this.translate.instant('Last Name');
                break;
            case 'email':
                label = this.translate.instant('Email');
                break;
            case 'phone':
                label = this.translate.instant('Phone Number');
                break;
            case 'message':
                label = this.translate.instant('Appointment Reason');
                break;
            case 'agreement':
                label = this.translate.instant('I agree that my submitted data is being collected and stored.');
                break;
        }
        return label;
    }

    resetValidation(): void {
        this.isMissingField = true;
        this.invalidFields = [];
    }

    onClickSubmit(data): undefined {
        if (this.formdata.invalid) {
            this.resetValidation();
            for (const key in this.formdata.controls) {
                if (this.formdata.controls[key].invalid && !this.formdata.controls[key].value) {
                    this.invalidFields.push(this.getContactFormFieldLabel(key));
                    if (this.formdata.controls.value === '') {
                        this.isMissingField = true;
                    }
                }
            }
            return;
        }

        const formdata = {
            firstname: this.formdata.controls.firstname.value,
            lastname: this.formdata.controls.lastname.value,
            email: this.formdata.controls.email.value,
            phone: this.formdata.controls.phone.value,
            message: this.formdata.controls.message.value,
            agreement: this.formdata.controls.agreement.value
        } as Contact;

        this.siteService.PostMessage(formdata)
            .subscribe(response => {
                this.submittedMail = true;
            }, error => {
                console.warn(error.responseText);
                console.log({ error });
            });
    }

    moveUrl(path): void {
        const route = this.siteService.navigateMenu.find(p => p.path === path);
        const param = route.section ? {queryParams: { section: route.section }} : undefined;
        if (route) {
            this.router.navigate([route.path], param);
        }
    }

    getLang(): string {
        return sessionStorage.getItem('selectedLang') || 'en';
    }

    sanitizeUrl(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
